import * as React from 'react';
import { Breadcrumbs, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function PageHeader({ title, subtitle, breadcrumbs = [], actions }) {
  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      spacing={2}
      alignItems={{ xs: 'flex-start', md: 'center' }}
      justifyContent="space-between"
      sx={{ mb: 1 }}
    >
      <Stack spacing={0.5}>
        {breadcrumbs?.length > 0 && (
          <Breadcrumbs aria-label="breadcrumb">
            {breadcrumbs.map((el, idx) => {
              const last = idx === breadcrumbs.length - 1;
              const [label, to] = el;
              return (
                <Link
                  key={`bc-${idx}`}
                  component={RouterLink}
                  to={to}
                  underline="hover"
                  color={last ? 'text.primary' : 'inherit'}
                  aria-current={last ? 'page' : undefined}
                  sx={{ fontWeight: last ? 600 : 500 }}
                >
                  {label}
                </Link>
              );
            })}
          </Breadcrumbs>
        )}
        <Typography variant="h5">{title}</Typography>
        {!!subtitle && (
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        )}
      </Stack>
      {actions ? <Stack direction="row" spacing={1.5}>{actions}</Stack> : null}
    </Stack>
  );
}





